import axios from 'axios'


export default {
    namespaced: true,
    state: {
        accessToken: '',
        user: {},
        activeUser: '',
        invalidLogin: true
    },
    getters: {
        accessToken(state) {
            // return localStorage.getItem('access_token') === null ? state.tokenLocal : localStorage.getItem('access_token')
            return localStorage.getItem('access_token') === null ? state.accessToken : localStorage.getItem('access_token')
            // return state.accessToken
        },
        user(state) {
            //return localStorage.getItem('user') === null ? state.user : JSON.parse(localStorage.getItem('user'))
            return localStorage.getItem('user') === null ? state.user : JSON.parse(localStorage.getItem('user'))
            //return state.user
        },
        getActiveUser(state) {
            return state.activeUser
        },
        invalidLogin(state) {
            return state.invalidLogin
        },
        isLoggedin(state){
            //const hasUserRole = state.user.roles.some(role => role.id == 2);
            //const hasAccount = state.user.accounts[0].Acctnum !== undefined;
            //return state.user.data !== undefined && hasUserRole && hasAccount ? true : false
            //return state.user.data !== undefined && state.user.data.login !== undefined ? state.user.data.login : false
            return localStorage.getItem('user') === null ? state.user.id !== undefined : true
        },
    },
    actions: {
        isAuthenticated({getters, commit, dispatch}) {
            //Check with api that token is valid
            return new Promise((resolve, reject) => {
                let data = '';
                if (getters.accessToken === null || getters.accessToken === undefined) {
                    reject({error: '👾 no token'})
                }
                let token = getters.accessToken;
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/api/tokenLogin',
                    headers: {
                        'Authorization': token ? 'Bearer ' + token : ''
                    },
                    data: data
                };
                axios(config)
                    .then(function (response) {
                        if (response.data.message == 'mfa required') {
                            reject({mfa:true});
                        } else if (response.data.name == 'Error') {
                            reject(response.data.name);
                        } else if (response.data.data[0].accounts[0].terms === 'CREDIT HOLD'){
                            dispatch('clearVToken')
                            reject({badterms: true})
                        } else if (response.data.login) {
                            commit('setUser', response.data.data[0])
                            commit('setInvalidLogin', false)
                            resolve(response.data)
                        } else {
                            reject({error: true})
                        }
                    })
                    .catch(function (error) {
                        if (!error.status) {
                            console.log('Error if', error)
                            reject(error);
                        } else {
                            reject(error);
                        }
                    });
            });
        },
        login({commit}, {username, password}) {
            return new Promise((resolve, reject) => {
                let data = {username, password};
                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/login',
                    data: data
                };

                axios(config)
                    .then(function (response) {
                        if (response.data.token) {
                            commit('setAccessToken', response.data.token);
                            commit('setInvalidLogin', false)
                        } else {
                            commit('setInvalidLogin', true)
                        }
                        resolve(response.data)
                    })
                    .catch(function (error) {
                        console.log('Error', error)
                        reject(error);
                    });
            })
        },
        ssoLogin({commit}, token) {
            return new Promise((resolve, reject) => {
                let data = {}
                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/api/exLogin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token.token
                    },
                    data: data
                }

                axios(config)
                    .then(response => {
                        console.log('xres', response)
                        commit('setAccessToken', response.data.data.token);
                        commit('setInvalidLogin', false)
                        resolve('sso datas',response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        login2({commit, dispatch}, {username, password}) {
            return new Promise((resolve, reject) => {
                let data = {username, password};
                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/api/login',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data
                };

                axios(config)
                    .then(async function (response) {
                        //localStorage.setItem('access_token', token)
                        if (response.data.firsttime !== undefined && response.data.firsttime) {
                            dispatch('clearVToken')
                        }else{
                            localStorage.removeItem('vuser')
                            localStorage.removeItem('vtoken')
                        }

                        if (response.data.data !== undefined &&
                            response.data.data.token !== undefined &&
                            response.data.data.token !== '') {
                            commit('setAccessToken', response.data.data.token);
                            commit('setInvalidLogin', false)
                            //await dispatch('isAuthenticated')
                        } else {
                            commit('setInvalidLogin', true)
                        }
                        resolve(response.data)
                    })
                    .catch(function (error) {
                        console.log('Error', error)
                        reject(error);
                    });
            })
        },
        resetPassword(_, options) {
            return new Promise((resolve, reject) => {
                let data = {...options}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/reset-password',
                    data: data
                }

                axios(config)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        resetCheck(_, options) {
            return new Promise((resolve, reject) => {
                let data = {}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/reset-password-check/'+options.token+'/'+options.email,
                    data: data
                }

                axios(config)
                    .then(response => {
                        resolve(response.status)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        forgotEmailCheck({state}, email) {
            return new Promise((resolve, reject) => {
                state.forgotid = email
                let data = {email}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/forgot-password',
                    data: data
                }

                axios(config)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        forgotEmail({state}, email) {
            return new Promise((resolve, reject) => {
                state.email = email
                let data = {...email}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/forgotEmail',
                    data: data
                }

                axios(config)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        verifyEmail({state}, vid) {
            return new Promise((resolve, reject) => {
                state.vid = vid
                let data = {vid}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/verifyEmail',
                    data: data
                }
                axios(config)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        clearVToken({commit}){
            localStorage.removeItem('access_token')
            localStorage.removeItem('user')
            commit('setAccessToken', '');
            commit('setUser', {});
            commit('setInvalidLogin', true)
            localStorage.removeItem('vuser')
            localStorage.removeItem('vtoken')
        },
        logout({commit}) {
            return new Promise((resolve) => {
                //find a way to clear all vue states
                commit('setAccessToken', '')
                commit('setUser', {})
                commit('setInvalidLogin', true)
                //commit('sideMenu/setSideMenuOrdered', '')
                localStorage.clear()
                resolve()
            })
        },
        getActiveUser({commit}, {email}) {
            return new Promise((resolve, reject) => {
                let data = {email}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/loginProblems/checkUserActive',
                    data: data
                }
                axios(config)
                    .then(response => {
                        commit('setActiveUser', response.data.data.active_account)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        passwordReset({email}) {
            return new Promise((resolve, reject) => {
                let data = {email}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/loginProblems/sendPasswordReset',
                    data: data
                }
                axios(config)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        },
        otherLoginProblems({email, problem}) {
            return new Promise((resolve, reject) => {
                let data = {email, problem}
                let config = {
                    method: 'post',
                    url: process.env.VUE_APP_API_SERVER + '/loginProblems/sendLoginProblems',
                    data: data
                }
                axios(config)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        if (!error.status) {
                            console.log('Error if', error)
                        } else {
                            reject(error)
                        }
                    })
            })
        }
    },
    mutations: {
        setAccessToken(state, token) {
            if(token !== '') {
                localStorage.setItem('access_token', token)
            }
            state.accessToken = token;
        },
        setUser(state, user) {
            if(Object.keys(user).length !== 0) {
                localStorage.setItem('user', JSON.stringify(user))
            }
            state.user = user;
        },
        setActiveUser(state, activeAccount) {
            state.activeUser = activeAccount
        },
        setInvalidLogin(state, invalidLogin) {
            state.invalidLogin = invalidLogin
        }
    }
}